import {
  type TInsuranceCompact,
  type TInsurancesResponse
} from '@/types/insuranceMapper';
import { type TInsurances } from '@/types/store';

export const insuranceTableMapper = (
  insurances: TInsurancesResponse
): TInsurances => {
  return {
    total: insurances.total,
    pageCount: insurances.page_count,
    data: insurances.data.map(
      (insurance) =>
        ({
          brand: insurance.model?.brand.name || '',
          clientIin: insurance.client?.client_iin || '',
          clientPhone: insurance.client?.phone_number || '',
          contractDate: insurance.contract_date || '',
          createDate: insurance.create_date,
          dealer: insurance.dealer?.name || '',
          firstName: insurance.client?.first_name || '',
          insuranceAmount: insurance.insurance_summ || '',
          insurancePremium: insurance.insurance_prem || '-',
          lastName: insurance.client?.last_name || '',
          middleName: insurance.client?.middle_name || '',
          model: insurance.model?.name || '',
          product: {
            code: insurance.product_type?.code || '',
            name: insurance.product_type?.name || ''
          },
          status: insurance.status,
          user: {
            first_name: insurance.user?.first_name || '',
            last_name: insurance.user?.last_name || '',
            middle_name: insurance.user?.middle_name || ''
          },
          uuid: insurance.uuid,
          year: insurance.year || ''
        }) satisfies TInsuranceCompact
    )
  };
};
